const digitalOpen = [
  {
    id: 'digital-strengths',
    courseNumber: 1,
    title: 'זיהוי דיוק ומינוף החוזקות',
    summary: 'לזהות את החוזקות האמיתיות שלכם ולהפוך אותן לכלי מנהיגות ביומיום.',
    description:
      'מסלול דיגיטלי לזיהוי מדויק של החוזקות האישיות שלכם ולמינוף מעשי שלהן בבית, בעבודה ובקשרים.',
    price: '149 ₪',
    includes: [
      'מיפוי חוזקות אישי מבוסס שיטה',
      'תרגילים קצרים ליישום יומיומי',
      'כלים להעצמת החוזקות בסיטואציות אמיתיות',
    ],
    details: {
      duration: '4 שבועות',
      level: 'לכל הרמות',
      format: 'דיגיטלי — באפליקציה',
      price: '149 ₪',
      audience: 'כל מי שרוצה להכיר ולמנף את החוזקות שלו',
    },
  },
];

const digitalLocked = [
  {
    id: 'digital-purpose-values',
    courseNumber: 2,
    title: 'ייעוד וערכים',
    summary: 'לבנות ייעוד אישי וערכים שמנחים החלטות ומנהיגות בחיים.',
    description:
      'קורס דיגיטלי לגיבוש ייעוד אישי וערכי ליבה — ולהפוך אותם לשפה מנהיגותית שמכוונת פעולה.',
    price: '149 ₪',
    includes: [
      'תהליך לגיבוש ייעוד וערכים',
      'מסגרת לקבלת החלטות מבוססת ערכים',
      'תרגולים ליישום בעבודה ובחיים האישיים',
    ],
    details: {
      duration: '4 שבועות',
      level: 'לכל הרמות',
      format: 'דיגיטלי — באפליקציה',
      price: '149 ₪',
      audience: 'מנהלים, הורים וכל מי שרוצה מנהיגות עם משמעות',
    },
  },
  {
    id: 'digital-self-presentation',
    courseNumber: 3,
    title: 'הצגה עצמית',
    summary: 'להציג את עצמכם בביטחון, בבהירות ובאותנטיות.',
    description:
      'למדו להציג את עצמכם בצורה משכנעת ואמיתית — בפגישות, מצגות, ראיונות ומפגשים חשובים.',
    price: '149 ₪',
    includes: [
      'מבנה להצגה עצמית ברורה וזכירה',
      'תרגול סיפור אישי ומסר מנהיגותי',
      'טיפים לנוכחות, שפה גוף ותקשורת מקוונת',
    ],
    details: {
      duration: '3 שבועות',
      level: 'לכל הרמות',
      format: 'דיגיטלי — באפליקציה',
      price: '149 ₪',
      audience: 'סטודנטים, מנהלים וכל מי שרוצה להשפיע בהצגה',
    },
  },
  {
    id: 'digital-gratitude',
    courseNumber: 4,
    title: 'חשיבה חיובית והוקרת תודה',
    summary: 'לחזק גישה חיובית והוקרה שמזינות מנהיגות ויחסים.',
    description:
      'כלים דיגיטליים לחשיבה חיובית, הוקרת תודה והרגלים שמחזקים אותכם ואת הסביבה שלכם.',
    price: '149 ₪',
    includes: [
      'הרגלים יומיים לחשיבה חיובית',
      'תרגול הוקרת תודה ממוקד',
      'קישור בין גישה חיובית למנהיגות אפקטיבית',
    ],
    details: {
      duration: '3 שבועות',
      level: 'לכל הרמות',
      format: 'דיגיטלי — באפליקציה',
      price: '149 ₪',
      audience: 'כל מי שרוצה אנרגיה ומנהיגות מתוך שפע',
    },
  },
];

export const ACADEMY_COURSE_CATALOGS = {
  digital: {
    viewId: 'courses-digital',
    pageTitle: 'קורסים דיגיטליים',
    pageLead: 'למידה בקצב שלכם — בחרו מסלול והיכנסו לקורס.',
    kicker: 'מסלול דיגיטלי',
    open: digitalOpen,
    locked: digitalLocked,
  },
};

export function getCatalogByView(view) {
  if (view === 'courses-digital') return ACADEMY_COURSE_CATALOGS.digital;
  return null;
}

export function catalogCourseEntries(catalog) {
  return [
    ...catalog.open.map((course) => ({ course, locked: false })),
    ...catalog.locked.map((course) => ({ course, locked: true })),
  ];
}
